import { cloneDeep, get, unset } from 'lodash-es';

/**
 * Removes the domainEntityId from an entity data object.
 *
 * This utility creates a deep clone of the provided data object and
 * removes the domainEntityId attribute from the entity metadata if it exists.
 * This is useful when preparing entity data for operations where the existing
 * domainEntityId should not be persisted (clone)
 *
 * @param {any} data - The entity data object containing potential domainEntityId
 * @returns {any} A clone of the original data with domainEntityId removed if it existed
 *
 * @example
 * // Original data
 * const entityData = {
 *   attributes: {
 *     entityMetadata: {
 *       domainEntityId: '123456',
 *       otherProperty: 'value'
 *     }
 *   }
 * };
 *
 * // After using the utility
 * const cleanedData = removeDomainEntityId(entityData);
 * // Result:
 * // {
 * //   attributes: {
 * //     entityMetadata: {
 * //       otherProperty: 'value'
 * //     }
 * //   }
 * // }
 */
export const removeDomainEntityId = (data: any) => {
  const clonedData = cloneDeep(data);

  const domainEntityIdPath = 'attributes.entityMetadata.domainEntityId';

  const domainEntityId = get(clonedData, domainEntityIdPath);

  if (domainEntityId) {
    unset(clonedData, domainEntityIdPath);
  }

  return clonedData;
};
